import {
  AfterViewInit,
  DestroyRef,
  Directive,
  HostListener,
  inject,
  Inject,
  InjectionToken,
  Input,
  Optional,
  Provider,
  Self
} from '@angular/core';
import { TimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { TranslateService } from '@ngx-translate/core';

export const DI_TIME_PICKER_UNIT_TEXT = new InjectionToken<string>('Text to be displayed after the input format');

export function provideTimePickerUnitText(text: string): Provider {
  return {
    provide: DI_TIME_PICKER_UNIT_TEXT,
    useValue: text
  };
}

@Directive({
  selector: 'kendo-timepicker[qpointTimePickerUnit]',
  standalone: true
})
export class QPointTimePickerUnitDirective implements AfterViewInit {
  private destroyRef = inject(DestroyRef);
  private translate = inject(TranslateService);
  private observer: MutationObserver;

  @Input() qpointTimePickerUnit: string | undefined = undefined;

  @HostListener('blur') onBlur() {
    this.updateInputElement();
  }

  constructor(
    @Self() @Optional() public kendoTimepicker: TimePickerComponent,
    @Inject(DI_TIME_PICKER_UNIT_TEXT) @Optional() private unitText: string
  ) {
    this.observer = new MutationObserver(() => this.updateInputElement());

    this.destroyRef.onDestroy(() => {
      this.observer.disconnect();
    })
  }

  get text(): string | undefined {
    return this.qpointTimePickerUnit || this.unitText;
  }

  private get inputElement(): HTMLInputElement | undefined {
    return this?.kendoTimepicker?.dateInput?.inputElement;
  }

  ngAfterViewInit() {
    if (this.inputElement) {
      this.updateInputElement();

      this.observer.observe(this.inputElement, {attributes: true});
    }
  }

  updateInputElement() {
    if(this.kendoTimepicker?.value && this.inputElement !== document.activeElement) {
      const input = this.inputElement;
      const value = input?.value.replace(new RegExp(this.translate.instant(this.qpointTimePickerUnit || this.unitText), 'g'), '').trim();
      input.value = `${value} ${this.translate.instant(this.qpointTimePickerUnit || this.unitText)}`;
    }
  }
}
